import { html, View, type Html } from 'rune-ts';
import type { Button } from '../Button/Button';
import type { ButtonSnsIcon } from '../ButtonSnsIcon/ButtonSnsIcon';
import type { Icon } from '../Icon/Icon';
import type { Typo } from '../Typo/Typo';
import klass from './Link.module.scss';

export interface LinkData {
  label: Typo | Button | Icon | ButtonSnsIcon | Html | string;
  href: string;
}

export interface LinkOption {
  target?: '_self' | '_blank' | '_parent' | '_top' | '_unfencedTop';
  title?: string;
  klass?: string;
  rel?:
    | 'alternate'
    | 'author'
    | 'bookmark'
    | 'external'
    | 'help'
    | 'license'
    | 'next'
    | 'nofollow'
    | 'noreferrer'
    | 'prev'
    | 'privacy-policy'
    | 'search'
    | 'tag'
    | 'terms-of-service';
  download?: boolean;
}

export class Link extends View<LinkData> {
  constructor(
    data: LinkData,
    public option: LinkOption = {},
  ) {
    super(data);
  }

  override template() {
    const { label, href } = this.data;
    const { target, title, rel, download } = this.option;

    return html`<a
      class="${klass.link}${this.option.klass ? html` ${this.option.klass}` : ''}"
      href="${href ?? ''}"
      target="${target ?? '_self'}"
      title="${title ?? ''}"
      ${rel ? `rel = ${rel}` : ''}
      ${download ? 'download' : ''}
    >
      ${label}
    </a> `;
  }
}
